// glossary.js — ARTEFATTO TESTATO (B2.17): termine → label IT unica per la shell.
// Regola: NESSUNA label utente hardcodata nei componenti shell (scan statico in
// server/src/lib/shell-glossary.test.js); ogni testo visibile passa da qui.
// Le label dei moduli VINCONO sulla label di registrazione (design §3/§6.1):
// oggi coincidono con quelle mostrate da workspace-host (parità R1 verificata nel test):
//   proc  → 'Procurement'      (wsh MOD_LABELS.proc)
//   amm   → 'Amministrazione'  (wsh MOD_LABELS.amm)
//   cont  → 'Contabilità'      (wsh: label 'Cont' → special-case 'Contabilità', qui muore l'hardcode wsh:112)
//   dash  → 'Cruscotto'        (label di registrazione dashboard-module.js:355)
//   sop   → 'SOP'              (label di registrazione sop-module.js:260)
//   email → 'Posta'            (label di registrazione email-module.js:576)
// Le chiavi nav (proc.suppliers, email.inbox, …) arrivano con R3/R4 (nav-items).

export const GLOSSARY = {
  // moduli — RAIL_ORDER §3 (Cruscotto in testa)
  dash: 'Cruscotto',
  proc: 'Procurement',
  amm: 'Amministrazione',
  cont: 'Contabilità',
  email: 'Posta',
  sop: 'SOP',
  // sottotitoli dei moduli (ondata 6): descrizione breve nell'header di contesto
  // del sottomenù — un modulo senza sottotitolo censito mostra solo il titolo.
  'dash.subtitle': 'Agenda e attività',
  'proc.subtitle': 'Ricerche commerciali e fornitori',
  'amm.subtitle': 'Fiscale e personale',
  'cont.subtitle': 'Prima nota e bilancio',
  'email.subtitle': 'Email aziendale',
  'sop.subtitle': 'Procedure operative',
  // chrome della shell (MobileBar R1)
  'shell.modbar.change_module': 'Cambia modulo',
  'shell.modbar.sections_menu': 'Menu sezioni',
  'shell.modbar.menu': 'Menu',
  'shell.modsheet.title': 'Vai al modulo',
  // chrome della shell (Rail R2 / Submenu R3) — l'header dello sheet sezioni
  // mobile è dall'ondata 6 il titolo+sottotitolo del modulo (niente più chiave
  // shell.secsheet.title: il contesto lo dà il modulo stesso)
  'shell.rail.aria': 'Moduli',
  'shell.submenu.aria': 'Sezioni del modulo',
  // zona UTENTE (ondata 6): pill + lingua + logout vivono nel fondo del RAIL
  // (desktop) e del modsheet (mobile) — resa unica in UserZone.jsx
  'shell.user.aria': 'Utente',
  'shell.user.logout': 'Esci',
  'shell.user.lang_aria': 'Lingua',
  'shell.user.lang_en': 'EN',
  'shell.user.lang_it': 'IT',
  // sezioni sottomenù Procurement (R3) — IT unico, parità con l'i18n IT del monolite
  // (chiude il finding "IT/EN misto sistematico" dell'audit UI/UX lente 4.B)
  // 'Panoramica' (ondata 6): anche il gruppo di testa ha l'intestazione — le
  // sezioni del sottomenù sono SEMPRE divise e intitolate, nessun gruppo anonimo.
  'proc.section.overview': 'Panoramica',
  'proc.section.sourcing': 'Approvvigionamento',
  'proc.section.catalog': 'Catalogo',
  'proc.section.fulfillment': 'Spedizioni',
  'proc.section.market': 'Mercato',
  'proc.section.org': 'Organizzazione',
  // voci sottomenù Procurement (R3) — un nome per concetto (audit lente 4.B:
  // 'Centro Azioni' come nel bottone della dashboard, mai più 'Action Center')
  'proc.dashboard': 'Dashboard',
  'proc.action-center': 'Centro Azioni',
  'proc.suppliers': 'Fornitori',
  'proc.conversations': 'Conversazioni',
  'proc.campaigns': 'Campagne',
  'proc.whatsapp': 'WhatsApp',
  'proc.products': 'Prodotti',
  'proc.categories': 'Categorie',
  'proc.tags': 'Tag',
  'proc.orders': 'Ordini',
  'proc.warehouse': 'Magazzino',
  'proc.competitors': 'Concorrenti',
  'proc.monitoring': 'Monitoraggio',
  'proc.identities': 'Identità',
  'proc.conflicts': 'Conflitti',
  'proc.team': 'Team',
  'proc.users': 'Utenti (admin)',
  'proc.audit': 'Registro attività',
  'proc.templates': 'Template',
  'proc.profile': 'Il mio profilo',
  'proc.settings': 'Impostazioni',
  // azioni rapide del modulo proc (footer del sottomenù: proxy sui bottoni
  // nascosti del #sidebar — nessuna funzione persa nascondendo la sidebar)
  'proc.quick_quote': 'Preventivo veloce',
  'proc.quick_log': 'Registra azione',
  // ===== R4: sottomenù unificato dei 5 ospiti (design §10) =====
  // messaggi dei bridge/adapter (§6.2: MAI proxy silenzioso)
  'shell.bridge.missing': 'Voce non disponibile: ',
  'shell.bridge.fallback': ': menu unificato non disponibile — uso la navigazione interna del modulo',
  // ===== R7: outlet del lazy-load (design §9.3, B2.18) =====
  'shell.loader.loading': 'Caricamento di ',
  'shell.loader.failed': 'Modulo non caricato: ',
  'shell.loader.error_hint': 'Controlla la connessione e riprova.',
  'shell.loader.retry': 'Riprova',
  'shell.loader.close': 'Chiudi',
  'shell.loader.unknown': 'Modulo non disponibile: ',
  // ===== F3.3 (ondata 16): coda-di-intento host (host.js) =====
  // il rail admin non è mai comparso entro il tetto di tentativi: il click
  // dell'utente NON va perso in silenzio — si dichiara quale modulo non si è aperto
  'shell.host.unreachable': 'Modulo non aperto: ',
  // Cruscotto (dash): pagina unica, le voci sono le sue SEZIONI reali
  // (dashboard-module.js: KPI, calendario, agenda, "Le mie task")
  'dash.section.overview': 'Panoramica',
  'dash.kpi': 'KPI',
  'dash.calendar': 'Calendario',
  'dash.agenda': 'Agenda',
  'dash.tasks': 'Le mie task',
  // SOP: le due schede reali (sop-module.js state.tab: templates | runs)
  'sop.section.main': 'Procedure operative',
  'sop.templates': 'Procedure',
  'sop.runs': 'In corso',
  // Posta (email): viste reali (state.view personal|followup) + pannelli di
  // gestione (impostazioni casella, regole follow-up, dipartimenti admin)
  'email.section.views': 'Cartelle',
  'email.inbox': 'In arrivo',
  'email.followup': 'Follow-up',
  'email.section.manage': 'Gestione',
  'email.settings': 'Impostazioni casella',
  'email.fu-rules': 'Regole follow-up',
  'email.departments': 'Dipartimenti',
  // Contabilità (bridge §6.2 sui .nav-item della sidebar interna FROZEN):
  // label = ESATTAMENTE quelle di PAGES dentro contabilita-module.js (parità
  // asserita da shell-guest-adapters.test.js) — servono anche da guardia
  // anti-deriva nel resolveTarget (text).
  'cont.section.guida': 'Guida',
  'cont.istruzioni': 'Istruzioni',
  'cont.section.config': 'Configurazione',
  'cont.setup': 'Setup',
  'cont.pianoconti': 'Piano Conti',
  'cont.anagrafica': 'Anagrafica',
  'cont.preset': 'Preset Scritture',
  'cont.section.input': 'Input',
  'cont.notefast': 'Note Fast',
  'cont.fatture': 'Fatture',
  'cont.estratticonto': 'Estratti Conto',
  'cont.banche': 'Banche',
  'cont.bancasync': 'Sync Banca',
  'cont.cespiti': 'Cespiti',
  'cont.import': 'Import (XML/Excel)',
  'cont.chiusure': 'Allineamento',
  'cont.section.core': 'Core',
  'cont.primanota': 'Prima Nota',
  'cont.registra-bulk': 'Registra in PN (bulk)',
  'cont.opspeciali': 'Op. Speciali',
  'cont.riconciliazione': 'Riconciliazione',
  'cont.section.consult': 'Consultazione',
  'cont.ricerca': 'Ricerca globale',
  'cont.consultazione': 'Consultazione',
  'cont.persoggetto': 'Per Soggetto',
  'cont.scadenzario': 'Scadenzario',
  'cont.section.report': 'Report fiscali',
  'cont.liquidazioneiva': 'Liquidazione IVA',
  'cont.scadenzefiscali': 'Scadenze Fiscali',
  'cont.registrocrediti': 'Registro Crediti',
  'cont.bilancio': 'Bilancio',
  'cont.section.sistema': 'Sistema',
  'cont.impostazioni': 'Impostazioni',
  // Amministrazione (bridge sugli .amm-link[data-page] di admin-module, che NON
  // si tocca): label = ESATTAMENTE quelle di NAV_GROUPS (parità asserita dal test)
  'amm.section.main': 'Scadenzario',
  'amm.cruscotto': 'Cruscotto',
  'amm.resoconto': 'Resoconto',
  'amm.personale': 'Costo personale',
  'amm.voci': 'Voci & trasferte',
  'amm.esercizi': 'Bilanci e archivio',
  'amm.calendario': 'Calendario',
  'amm.scadenzario': 'Regole degli obblighi',
  'amm.f24': 'Pagamenti F24',
  'amm.tributi': 'Imposte dell\'anno',
  'amm.atti': 'Atti e avvisi',
  'amm.rateizzazioni': 'Piani di rientro',
  'amm.riepilogo': 'Riepilogo annuale',
  'amm.profilo': 'Profilo azienda',
  'amm.section.anagrafiche': 'Anagrafiche',
  'amm.veicoli': 'Veicoli',
  'amm.polizze': 'Polizze',
  'amm.documenti': 'Documenti',
  'amm.dipendenti': 'Dipendenti',
  'amm.immobili': 'Immobili',
  'amm.crediti': 'Crediti d\'imposta',
  'amm.cantieri': 'Cantieri',
};

// label(key) — risoluzione OBBLIGATORIA: chiave mancante = throw (B2.17,
// "glossKey orfana = fail"). Il throw è incondizionato: la chiamata con chiave
// ignota è un bug di programmazione, non uno stato runtime.
export function label(key) {
  if (!Object.prototype.hasOwnProperty.call(GLOSSARY, key)) {
    throw new Error('[glossary] chiave mancante: "' + key + '" — aggiungila in client/src/shell/glossary.js (B2.17)');
  }
  return GLOSSARY[key];
}

export function hasLabel(key) {
  return Object.prototype.hasOwnProperty.call(GLOSSARY, key);
}

// moduleLabel(id, fallback) — label di un modulo nel rail/modsheet.
// Modulo censito nel glossario → vince il glossario (design §3).
// Modulo NON censito (workspace futuro registrato a runtime) → parità wsh:
// si mostra la label di registrazione, mai stringa vuota.
export function moduleLabel(id, fallback) {
  if (hasLabel(id)) return GLOSSARY[id];
  return fallback || id;
}

// moduleSubtitle(id) — sottotitolo (descrizione breve) del modulo per l'header
// di contesto del sottomenù (ondata 6). Modulo senza sottotitolo censito → ''
// (l'header mostra solo il titolo): il sottotitolo è ARRICCHIMENTO, mai blocco.
export function moduleSubtitle(id) {
  const k = id + '.subtitle';
  return hasLabel(k) ? GLOSSARY[k] : '';
}
